import { techCards } from '../constants';
import { SectionWrapper } from '../hoc';
import { styles } from '../styles';

const TechCard = ({ title, description, Img }) => {
  if (!title || !description || !Img) {
    throw new Error('TechCard requires title, description, and Img');
  }

  return (
    <>
      <div>
        <div className="flex flex-row max-w-full sm:max-w-md">
          <div className="flex justify-center">
            <div className="flex-shrink-0 h-6 mr-2 mt-1 rtl:ml-2 rtl:mr-0 w-6">
              {Img && <Img />}
            </div>
          </div>
          <div className="mt-0.5">
            <h3 className="text-lg text-txt-primary font-semibold">{title}</h3>
            <p className="mt-0.5 text-txt-secondary">{description}</p>
          </div>
        </div>
      </div>
    </>
  );
};

const Tech = () => {
  return (
    <div className="mb-12">
      <div className={styles.sectionHeadText}>Technologies </div>
      <div className="mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
        {techCards.map((techCard, index) => (
          <TechCard key={index} {...techCard} />
        ))}
      </div>
    </div>
  );
};

export default SectionWrapper(Tech,'skills','bg-section-1');
